import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { store } from './store/store.js';

import ImageLoading from './components/alert/imageLoading.js';
import ErrorBoundary from './components/error/ErrorBoundary.jsx';

// Login se carga de forma estática: es la primera pantalla, no conviene
// pagar un chunk extra en el arranque.
import Login from './components/login/Login.jsx';

// El resto se carga bajo demanda (code-splitting por ruta). Esto saca del
// bundle inicial las dependencias pesadas (@mui/x-charts, x-data-grid,
// x-date-pickers, sweetalert2) que solo usan las pantallas internas.
const ForgetPassword = lazy(() => import('./components/forget_password/ForgetPassword.jsx'));
const Signup         = lazy(() => import('./components/signup/Signup.jsx'));
const Customer       = lazy(() => import('./components/customers/Customer.jsx'));
const FormCustomer   = lazy(() => import('./components/customers/FormCustomer.jsx'));
const Credit         = lazy(() => import('./components/credits/Credit.jsx'));
const Dashboard      = lazy(() => import('./components/dashboard/Dashboard.jsx'));
const Traceability   = lazy(() => import('./components/traceability/Traceability.jsx'));
const PanelAdmin     = lazy(() => import('./components/panel/PanelAdmin.jsx'));
const Users          = lazy(() => import('./components/users/Users.jsx'));
const ProtectedRoutes = lazy(() => import('./services/protectedRoutes.tsx'));

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <ErrorBoundary>
    <BrowserRouter>
      <Suspense fallback={<ImageLoading />}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/signup" element={<Signup />} />

          <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customer" element={<Customer />} />
            <Route path="/form_customer" element={<FormCustomer />} />
            <Route path="/credit" element={<Credit />} />
            <Route path="/traceability" element={<Traceability />} />
            <Route path="/panel_admin" element={<PanelAdmin />} />
            <Route path="/users" element={<Users />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
    </ErrorBoundary>
  </Provider>
);
